<template>
	<div class="custom-company__row">

		<div class="form__row form__row--floating">
			<input placeholder=" " type="text" :name="'company_name['+i+']'" :id="'company_name['+i+']'">
			<label :for="'company_name['+i+']'">Название компании</label>
		</div>

		<div class="form__row form__row--floating">
			<input placeholder=" " type="text" :name="'company_external_id['+i+']'" :id="'company_external_id['+i+']'">
			<label :for="'company_external_id['+i+']'">Код компании</label>
		</div>

		<button type="button" v-on:click="$emit('remove')" class="button-delete"></button>

	</div>
</template>

<script>
export default {
  props: ["i"]
};
</script>

<style scoped>
.form__row {
  margin-top: 0;
  width: 100%;
}
.button-delete {
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
}

@media (min-width: 768px) {
  .form__row {
    margin: 0;
    width: 100%;
    margin-right: 10px;
  }

  .button-delete {
    position: static;
    flex: none;
  }
}

@media (min-width: 1160px) {
  .button-delete {
    width: 10px;
    height: 10px;
  }
}
</style>
